import { useState } from 'react';
import api from '../Services/api';
import endpoints from '../Services/endpointAdmin';

/**
 * @returns { Object } - Mengembalikan fungsi postZakat, serta status loading dan error.
 */
const usePostInformasi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Fungsi untuk mengirim data ke backend.
   * @param { string } judul 
   * @param { string } foto 
   * @param { string } deskripsi 
   * @returns { Promise<Object> } - Mengembalikan data respons dari backend atau error.
   */
  const postInformasi = async (
    judul,
    deskripsi,
    isi,
    kategori,
    foto,
    tanggal,
    extra = {}
  ) => {
    setLoading(true);
    setError(null);

    try {
      const data = {
        judul,
        deskripsi,
        isi,
        tanggal,
        ...extra,
      };

      // Only include kategori and foto if they have values
      if (kategori !== undefined && kategori !== null && kategori !== '') {
        data.kategori = kategori;
      }
      if (foto !== undefined && foto !== null && foto !== '') {
        data.foto = foto;
      }

      const candidateEndpoints = (Array.isArray(endpoints.informasi?.create)
        ? endpoints.informasi.create
        : [endpoints.informasi?.create]).filter(Boolean);
      let lastError = null;

      for (const endpoint of candidateEndpoints) {
        try {
          const response = await api.post(endpoint, data, {
            headers: {
              'Content-Type': 'application/json',
            },
          });

          return response.data;
        } catch (err) {
          lastError = err;

          if (err?.response?.status !== 404) {
            throw err;
          }
        }
      }

      throw lastError || new Error('Endpoint informasi tidak ditemukan.');
    } catch (err) {
      console.error('Error uploading data:', err);
      setError(err.response?.data?.error || 'Terjadi kesalahan saat mengupload data.');
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { postInformasi, loading, error };
};

export default usePostInformasi;
